(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-constants.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-constants.js');

'use strict';

const POST_MESSAGE_SOURCES = {
  IFRAME: 'svs-iam-iframe',
  PARENT: 'svs-iam-parent'
};

const POST_MESSAGE_TYPES = {
  HEIGHT: 'height',
  PARENT_REDIRECT: 'parent-redirect',
  SHOW_DIALOG: 'show-dialog',
  SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
  SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
  SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
  PARENT_TRACK_EVENT: 'parent-track-event',
  PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved',
  GET_ONBOARDING_DATA: 'get-onboarding-data',
  FULLSCREEN: 'fullscreen',
  REMOVE_FULLSCREEN: 'remove-fullscreen',
  UPDATE_ONBOARDING_DATA: 'update-onboarding-data',
  PARENT_ONBOARDING_DATA_UPDATED: 'parent-onboarding-data-updated',
  SET_LOGIN_TYPE: 'set-login-type',
  UPDATE_PARENT_QUERYSTRING: 'update-parent-querystring',
  PARENT_QUERYSTRING_UPDATED: 'parent-querystring-updated',
  GET_PARENT_SLO: 'get-parent-slo',
  GOT_PARENT_SLO: 'got-parent-slo',
  DELETE_PARENT_SLO: 'delete-parent-slo',
  PARENT_SLO_DELETED: 'parent-slo-deleted',
  GET_SELECTED_SSN: 'get-selected-ssn',
  SELECTED_SSN: 'selected-ssn'
};

Object.assign(svs.accountservices.iamPostMessage, {
  POST_MESSAGE_SOURCES,
  POST_MESSAGE_TYPES
});

 })(window);